<main id="container" class="ui-g-12 ui-md-12 ui-sm-12">
  <div id="textDiv" class="ui-g-4 ui-md-4 ui-md-offset-2 ui-sm-12">
    <h1>
      Are you looking for a freelancer that does software development, digital
      marketing & SEO optimization ?
    </h1>
    <h4>Don't look any further!</h4>
    <table id="buttonsTable">
      <tr>
        <td>
          <button type="button" (click)="downloadCV()" class="btn btn-primary">
            Download CV
          </button>
        </td>
        <td id="contactButtonTD">
          <button
            id="contactButton"
            (click)="goToFiverr()"
            type="button"
            class="btn btn-outline-secondary"
          >
            Hire me now
          </button>
        </td>
      </tr>
    </table>
  </div>
  <div id="photoDiv" class="ui-g-6 ui-md-6 ui-sm-12">
    <img id="myPhoto" src="assets/images/lejdi-prifti.jpg" alt="Lejdi Prifti" />
  </div>
  <div id="bio" class="ui-g-12">
    <div id="photo" class="ui-g-6 ui-md-6 ui-sm-12">
      <img src="assets/images/lejdi-prifti-work.png" alt="Lejdi Prifti" />
    </div>
    <div id="text" class="ui-g-6 ui-md-6 ui-sm-12">
      <h2>About me</h2>
      <br />
      <h4>
        My name is Lejdi Prifti and I am a Full-Stack Software Developer in
        Tirana, Albania.
      </h4>
      <br />
      <h4>
        I gratuated from the University of Tirana, Albania in Business
        Informatics, and I have studied more about software development during
        my exchange semester at Linnaeus University, Vaxjo, Sweden.
      </h4>
      <br />
      <h4>
        I have been doing software development for more than 2 years working
        with different technologies and facing challenging problems.
      </h4>
      <br />
      <h4>
        As a freelancer, I offer top-quality digital solutions such as software
        development, digital marketing, and SEO optimization to clients all over
        the world.
      </h4>
    </div>
  </div>
  <div id="skills" class="ui-g-12">
    <h2>Skills</h2>
    <img src="assets/images/skills/html5.jpg" alt="HTML5" />
    <img src="assets/images/skills/css3.jpg" alt="CSS3" />
    <img src="assets/images/skills/javascript.png" alt="JS" />
    <img src="assets/images/skills/java.jpg" alt="Java" />
    <img src="assets/images/skills/typescript.jpg" alt="Typescript" />
    <img src="assets/images/skills/python.jpg" alt="Typescript" />
  </div>
  <div id="frameworks" class="ui-g-12">
    <h1>Technologies</h1>
    <img id="angular" src="assets/images/skills/angular.png" alt="Angular" />
    <img id="spring" src="assets/images/skills/spring.jpg" alt="Spring" />
    <img id="postgres" src="assets/images/skills/postgres.jpg" alt="Postgres" />
    <img id="git" src="assets/images/skills/git.jpg" alt="Git" />
  </div>
  <!--Testimonials-->
  <section id="testimonials" class="ui-g-12">
    <h2>Testimonials</h2>
    <table>
      <tr>
        <td>
          <article>
            <img
              class="quotes"
              src="../../../assets/images/quote.svg"
              alt="Testimonals' quotes"
            />
            <p>
              "I only give Lejdi the almost impossible SQL tasks that require
              next level coding skills. Every single time amazes me with the
              professional results, plus he does not stop until it works!
              Seriously, the best person I have used on Fiverr."
            </p>
            <h4>-Philip Dooley, Class Coach, Australia</h4>
          </article>
        </td>
        <td>
          <article>
            <img
              class="quotes"
              src="../../../assets/images/quote.svg"
              alt="Testimonals' quotes"
            />
            <p>
              "Lejdi went above and beyond to make sure we understood what he
              was teaching. He even took his time to create useful quizzes at
              the end of each class. He shared very useful real life tips to
              help us relate the classes with real life experiences. Thank you
              for your time."
            </p>
            <h4>-Opeyemi Ahmeed, CodeKidsLab, Saudi Arabia</h4>
          </article>
        </td>
      </tr>
      <tr>
        <td>
          <article>
            <img
              class="quotes"
              src="../../../assets/images/quote.svg"
              alt="Testimonals' quotes"
            />
            <p>
              "A very nice guy, who can deliver very fast great results. We‘ll
              be working with him further!"
            </p>
            <h4>-Vincent Kleemann, Preeda, Germany</h4>
          </article>
        </td>
        <td>
          <article>
            <img
              class="quotes"
              src="../../../assets/images/quote.svg"
              alt="Testimonals' quotes"
            />
            <p>
              "Lejdi was able to guide me through some hoops and was able to
              learn and understand key concepts pretty quickly good speaker and
              straight forward guy!"
            </p>
            <h4>-Sameer Sakaria, United States of America</h4>
          </article>
        </td>
      </tr>
    </table>
  </section>
  <section id="call" class="ui-g-12">
    <h2>I provide solutions for your business</h2>
    <h4>Contact me now</h4>
  </section>
</main>
